import { render, staticRenderFns } from "./pelunasanwofrm-settlement.vue?vue&type=template&id=2433216a&"
import script from "./pelunasanwofrm-settlement.vue?vue&type=script&lang=js&"
export * from "./pelunasanwofrm-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports